module.exports = __webpack_public_path__ + "static/img/房屋建筑.07e1bac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/房屋建筑.jpg
// module id = PpVI
// module chunks = 1